import React, { Component } from 'react';
import { ErrorMessage } from 'formik';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LabelR from '../../Simple/LabelR';

class Input extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggledIconValue: false,
    };
  }

  render() {
    const {
      field: { name, value, onChange = () => {}, onBlur = () => {} } = this.props,
      form: { touched = [], errors = [], setFieldValue = () => {} } = this.props,
      disabled = false,
      required,
      requiredFields = [name],
      label,
      placeholder,
      tabIndex,
      autoComplete,
      onKeyDown = () => {},
      lastPassIgnore,
      handleChange = () => {},
      handleBlur = () => {},
      iconClasses,
      secondLabel,
      withIcon = false,
      maxlength,
      className,
      showError,
      touchedEnabled = true,
    } = this.props;

    const allIconClasses = classNames({
      'input-group-text': true,
      'rounded-right': true,
      ...iconClasses,
    });

    const getType = () => {
      const { toggledIconValue } = this.state;
      const { type = 'text', toggledType = 'text' } = this.props;
      return toggledIconValue ? toggledType : type;
    };

    const getIcon = () => {
      const { toggledIconValue } = this.state;
      const { icon = 'eye', toggledIcon = 'eye-slash' } = this.props;
      return toggledIconValue ? toggledIcon : icon;
    };

    const isTouched = (name) => (touchedEnabled ? touched[name] : true);
    const classes = classNames('form-control', { 'is-invalid': (errors[name] && isTouched(name)) || showError }, className);

    const InputCtl = (
      <input
        type={getType()}
        className={classes}
        onKeyDown={onKeyDown}
        value={value}
        placeholder={placeholder}
        aria-describedby={`${name}Addon`}
        tabIndex={tabIndex}
        autoComplete={autoComplete}
        name={name}
        id={`${name}-input`}
        onChange={(e) => {
          onChange(e);
          const newValue = e.target.value;
          const changedFields = handleChange(newValue);
          handleAffectedFields(changedFields);
        }}
        onBlur={(e) => {
          onBlur(e);
          handleBlur(e);
        }}
        disabled={disabled}
        data-lpignore={lastPassIgnore}
        maxLength={maxlength}
      />
    );

    const onIconClick = (e) => {
      const { canToggleIcon, handleIconClick = () => {} } = this.props;
      const { toggledIconValue } = this.state;
      handleIconClick(e);
      if (!canToggleIcon) return;

      e.preventDefault();
      this.setState({
        toggledIconValue: !toggledIconValue,
      });
    };

    const handleAffectedFields = (affectedFields) => {
      if (affectedFields) {
        Object.keys(affectedFields).forEach((key) => setFieldValue(key, affectedFields[key]));
      }
    };

    return (
      <div className="form-group" id={`${name}-container-input`}>
        {label &&
          (required ? (
            <LabelR requiredFields={requiredFields} isEditable={!disabled} htmlFor={name} name={name}>
              {label}
            </LabelR>
          ) : (
            <label htmlFor={name} id={`${name}-label`}>
              {label}
            </label>
          ))}

        {secondLabel && (
          <>
            {' '}
            &nbsp; <label id={`${name}-label-second`}>{secondLabel}</label>{' '}
          </>
        )}
        {withIcon ? (
          <div className="input-group default-input-group" id={`${name}-div-icon`}>
            {InputCtl}
            <div className="input-group-append">
              <span className={allIconClasses} id={`${name}-span-icon`} onClick={onIconClick} onKeyPress={onIconClick}>
                <FontAwesomeIcon icon={getIcon()} />
              </span>
            </div>
          </div>
        ) : (
          InputCtl
        )}
        {isTouched(name) && errors[name] && <ErrorMessage name={name} component="div" className="invalid-feedback" />}
      </div>
    );
  }
}

export default Input;
